export const ADMIN = "admin";
export const USER = "user";

export const ROLES = {
  ADMIN: "admin",
  VENDOR: "vendor",
  CUSTOMER: "customer",
};
